// import { createStore } from 'vuex';

// const store = createStore({
//   state: {
//     // ステートの定義
//   },
//   mutations: {
//     // ミューテーションの定義
//   },
//   actions: {
//     // アクションの定義
//   }
// });

// export default store;

export default {};